import http from '@/shared/api/http'
import type { ApiResponse } from '@/shared/api/http/api/response.api'
import {
  apiNotificationHasUnread,
  apiNotificationMe,
  apiNotificationMeById,
  apiNotificationRead,
  apiNotificationReadAll,
  apiNotificationTotalCount,
  apiNotificationUnreadCount,
} from './notification.urls'
import type { NotificationCursorPage } from './types/notification.model'
import type { NotificationGetListInput } from './types/notification.param'

const toQuery = (input: NotificationGetListInput): string => {
  const params = new URLSearchParams()
  if (input.cursor) params.set('cursor', input.cursor)
  if (input.direction !== undefined) params.set('direction', String(input.direction))
  params.set('pageSize', String(input.pageSize))
  if (input.isRead !== undefined) params.set('isRead', String(input.isRead))
  if (input.keyword) params.set('keyword', input.keyword)
  return params.toString()
}

const getList = (input: NotificationGetListInput): Promise<ApiResponse<NotificationCursorPage>> =>
  http.get(`${apiNotificationMe}?${toQuery(input)}`)

const getUnreadCount = (): Promise<ApiResponse<number>> => http.get(apiNotificationUnreadCount)

const getTotalCount = (): Promise<ApiResponse<number>> => http.get(apiNotificationTotalCount)

const getHasUnread = (): Promise<ApiResponse<boolean>> => http.get(apiNotificationHasUnread)

const markRead = (id: string): Promise<ApiResponse> => http.post(apiNotificationRead(id))

const markAllRead = (): Promise<ApiResponse> => http.post(apiNotificationReadAll)

const remove = (id: string): Promise<ApiResponse> => http.delete(apiNotificationMeById(id))

const removeAllMine = (): Promise<ApiResponse> => http.delete(apiNotificationMe)

export const notificationService = {
  getList,
  getUnreadCount,
  getTotalCount,
  getHasUnread,
  markRead,
  markAllRead,
  remove,
  removeAllMine,
}

export default notificationService
